import React from "react";
import { transformDNI } from "services/Local-services";
import { etiquetaUnico } from "consts/asignaciones";
import EstadoAgenteChip from "components/UI/Chips/EstadoAgenteChip";

/**
 * Las dos columnas de permisos de una repartición: si admite horarios rotativos y si
 * admite guardias.
 *
 * Van como constante y se spreadean —`...COLUMNAS_DE_PERMISOS`— en vez de repetirse en
 * cada juego de títulos: son iguales en las tres vistas de reparticiones, y en breve
 * también en las de establecimientos.
 *
 * Los encabezados van en PLURAL, iguales a las etiquetas de los checkbox del modal: el
 * mismo dato tiene que llamarse igual donde se carga y donde se lee.
 *
 * "Horarios Rotativos" lleva el header en DOS RENGLONES para que la columna mida por su
 * contenido —dos letras— y no por el largo del título. La regla de la clase vive en
 * XGrid.module.scss, y OJO que no funciona en grillas con columnas agrupadas.
 *
 * La celda sale de `etiquetaSiNo` (consts/banderas), que da vacío cuando el back no manda
 * dato: ver la nota ahí.
 */
const COLUMNAS_DE_PERMISOS = [
  {
    field: "rotativos",
    headerName: "Horarios Rotativos",
    headerClassName: "header-dos-lineas",
    headerAlign: "center",
    align: "center",
    width: 110,
  },
  {
    field: "guardias",
    headerName: "Guardias",
    headerAlign: "center",
    align: "center",
    width: 100,
  },
];

export const usuariosXServicio = [
  {
    field: "fullName",
    headerName: "Apellido y Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "document",
    headerName: "Documento",
    type: "number",
    format: "number",
    width: 120,
  },
  {
    field: "documentType",
    headerName: "Tipo",
    width: 70,
  },
  {
    field: "gender",
    headerName: "Género",
    width: 70,
    align: "center",
  },
  {
    field: "birthDay",
    headerName: "Nacimiento",
    type: "date",
    format: "date",
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
  },
  {
    field: "rol",
    headerName: "Rol",
    minWidth: 120,
  },
  {
    field: "onboard",
    headerName: "Onboard",
    align: "center",
  },
  {
    field: "creationDate",
    headerName: "Alta",
    type: "date",
    format: "date",
  },
  {
    field: "status",
    headerName: "Estado",
  },
  {
    field: "statusDate",
    headerName: "Fecha",
    type: "date",
    format: "date",
  },
];
export const usuariosXServicioNavidad = [
  {
    field: "fullName",
    headerName: "Apellido y Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "document",
    headerName: "Documento",
    type: "number",
    format: "number",
    width: 120,
  },
  {
    field: "gender",
    headerName: "Género",
    width: 70,
    align: "center",
  },
  {
    field: "birthDay",
    headerName: "Nacimiento",
    type: "date",
    format: "date",
  },
  {
    field: "rol",
    headerName: "Rol",
    minWidth: 240,
  },
  {
    field: "onboard",
    headerName: "Onboard",
    align: "center",
  },
  {
    field: "creationDate",
    headerName: "Alta",
    type: "date",
    format: "date",
  },
  {
    field: "wallet",
    headerName: "Billetera",
  },
  {
    field: "status",
    headerName: "Estado",
  },
  {
    field: "statusDate",
    headerName: "Fecha",
    type: "date",
    format: "date",
  },
  {
    field: "asignaciones",
    headerName: "Asignaciones",
  },
  // {
  //     field: "consumo",
  //     headerName: "Consumo",
  // },
];
export const comerciosNavidad = [
  {
    field: "cuit",
    headerName: "CUIT",
    flex: 1,
    headerAlign: "right",
    align: "right",
    maxWidth: 180,
  },
  {
    field: "RZ",
    headerName: "Razon Social",
    minWidth: 380,
  },
  {
    field: "merchantNombre",
    headerName: "Nombre",
    minWidth: 400,
  },
  {
    field: "localidad",
    headerName: "Localidad",
    minWidth: 280,
  },
  {
    field: "fisicaJuridica",
    headerName: "Física/Jurídica",
    maxWidth: 180,
  },
  {
    field: "statusOperativo",
    headerName: "Estado Operativo",
    maxWidth: 200,
  },
  {
    field: "statusRegistro",
    headerName: "Estado de Registro",
    maxWidth: 150,
  },
  {
    field: "fechaAlta",
    headerName: "Fecha alta",
    type: "date",
    format: "date",
    maxWidth: 150,
  },
];
export const programasNavidad = [
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
  },
  {
    field: "cod",
    headerName: "Código",
    flex: 1,
  },
  {
    field: "inicio",
    headerName: "Inicio",
    flex: 1,
  },
  {
    field: "fin",
    headerName: "Fin",
    flex: 1,
  },
];
export const UsuariosGlobales = [
  {
    field: "fullName",
    headerName: "Apellido y Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "document",
    headerName: "Documento",
    type: "number",
    format: "number",
    width: 120,
  },
  {
    field: "gender",
    headerName: "Género",
    width: 70,
    align: "center",
  },
  {
    field: "birthDay",
    headerName: "Nacimiento",
    type: "date",
    format: "date",
  },
  {
    field: "nombreServicio",
    headerName: "Servicio",
    minWidth: 240,
  },
  {
    field: "rol",
    headerName: "Rol",
    minWidth: 240,
  },
  {
    field: "onboard",
    headerName: "Onboard",
    align: "center",
  },
  {
    field: "creationDate",
    headerName: "Alta",
    type: "date",
    format: "date",
  },
  {
    field: "status",
    headerName: "Estado",
  },
  {
    field: "statusDate",
    headerName: "Fecha",
    type: "date",
    format: "date",
  },
];

// Columnas propias y no las de Usuarios Globales, que las comparte esa otra pagina: aca el
// servicio es siempre el mismo —la vista cuelga de RNSALUD— asi que esa columna repetia el
// mismo texto en todas las filas, y ese ancho rinde mucho mas mostrando el mail.
export const usuariosInternos = [
  {
    field: "fullName",
    headerName: "Apellidos y Nombres",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "document",
    headerName: "Documento",
    type: "number",
    format: "number",
    width: 120,
  },
  {
    field: "gender",
    headerName: "Género",
    width: 100,
    align: "center",
  },
  {
    field: "birthDay",
    headerName: "Nacimiento",
    type: "date",
    format: "date",
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 220,
  },
  {
    field: "rol",
    headerName: "Rol",
    minWidth: 180,
  },
  {
    field: "onboard",
    headerName: "Onboard",
    align: "center",
  },
  {
    field: "creationDate",
    headerName: "Alta",
    type: "date",
    format: "date",
  },
  {
    field: "status",
    headerName: "Estado",
  },
  {
    field: "statusDate",
    headerName: "Fecha",
    type: "date",
    format: "date",
  },
];

export const rubrosTitles = [
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
];
export const zonasTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "hospitalCabecera",
    headerName: "Hospital de Cabecera",
    width: 250,
  },
];
export const nivelesTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "componenteMaximo",
    headerName: "Jerarquía Máxima",
    minWidth: 180,
  },
];
export const titulosTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "matricula",
    headerName: "Requiere Matrícula",
    flex: 1,
    maxWidth: 150,
  },
];
export const conveniosTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 140,
  },
  {
    field: "ley",
    headerName: "Ley",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "cargaSemanal",
    headerName: "Carga Semanal (hs)",
    flex: 1,
    minWidth: 160,
  },
];
export const funcionesTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 140,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "agrupamiento",
    headerName: "Agrupamiento",
    flex: 1,
    minWidth: 200,
  },
];

export const agrupamientoTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 140,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
    minWidth: 200,
  },
  {
    // La pinta la vista con un renderCell: el valor es un array de nombres, no un
    // texto, asi que sin renderCell la celda mostraria "[object Object]".
    field: "funciones",
    headerName: "Funciones",
    flex: 1,
    minWidth: 240,
    sortable: false,
  }
];

// Un feriado es el CONCEPTO ("Día del Trabajador"), sin fecha: las fechas viven en
// su serie. Por eso acá no hay columna de fecha ni de código —el modelo no tiene uno—.
export const feriadosTitles = [
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "tipo",
    headerName: "Tipo",
    width: 140,
  },
];

// Una fila = UNA fecha de un feriado, que es como las devuelve el servicio. Un mismo
// feriado aparece repetido, una vez por cada fecha que tenga cargada.
export const seriesFeriadosTitles = [
  
  {
    field: "fecha",
    headerName: "Fecha",
    width: 120,
    // `format: "date"` es el mecanismo de generateColumns: pasa el valor por
    // transformDate (2026-05-01 -> 01/05/2026).
    format: "date",
  },
  {
    field: "feriado",
    headerName: "Feriado",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "tipo",
    headerName: "Tipo",
    width: 140,
  },
];
export const cargosTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 140,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "componente",
    headerName: "Repartición asociada",
    flex: 1,
    minWidth: 240,
  },
  {
    // Mismo formato que las columnas de permisos de las reparticiones: Sí / No, y vacío
    // mientras el back no mande el dato.
    //
    // Es la primera señal de los permisos de un cargo y seguramente no la última: cuando
    // haya más de uno conviene mirarlos en conjunto antes de decidir cómo se muestran.
    field: "puedeEditar",
    headerName: "Puede editar",
    headerAlign: "center",
    align: "center",
    width: 120,
  },
];
export const agentesTitles = [
  {
    field: "apellidosNombres",
    headerName: "Apellidos y Nombres",
    flex: 1,
    maxWidth: 200,
    minWidth: 200,
  },
  {
    field: "documento",
    headerName: "DNI",
    width: 90,
    headerAlign: "right",
    align: "right",
    // La fila guarda el documento CRUDO: lo lee el modal de modificar y es lo que
    // ordena la grilla. Los puntos son solo presentación, por eso van acá.
    // Este renderCell pisa al generico de generateColumns, que spreadea el title
    // despues de los suyos.
    renderCell: ({ value }) =>
      value == null || value === "" ? "" : transformDNI(value),
  },
  {
    field: "legajo",
    headerName: "Legajo",
    width: 80,
  },
  {
    field: "convenio",
    headerName: "Régimen",
    minWidth: 120,
  },
  {
    field: "cargo",
    headerName: "Cargo",
    width: 150,
  },
  {
    field: "lugar",
    headerName: "Establecimiento, Mesa Principal",
    flex: 1,
    minWidth: 250,
  },
  // ── Mesas ───────────────────────────────────────────────────────────────
  // Las dos columnas de abajo viven bajo el header "Mesas" de `agentesColumnGroups`.
  // El grupo las referencia POR FIELD y tienen que quedar PEGADAS: el header padre
  // abarca columnas contiguas, no saltea.
  {
    field: "unique",
    headerName: "U",
    // Con una letra sola de encabezado, el tooltip es lo unico que explica que es.
    description: "¿Está en un solo establecimiento?",
    width: 40,
    headerAlign: "center",
    align: "center",
    // La fila guarda el codigo CRUDO ("Y"/"N") porque de ahi lo precarga el select del
    // modal de modificar. La traduccion es solo presentacion, por eso va aca.
    // Este renderCell pisa al generico de generateColumns, que spreadea el title
    // despues de los suyos.
    renderCell: ({ value }) => etiquetaUnico(value),
  },
  {
    field: "mesasCantidad",
    headerName: "Q",
    description: "Cantidad de mesas asignadas",
    width: 40,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "dob",
    headerName: "DOB",
    minWidth: 100,
    // Es una fecha y se muestra como todas: dd/mm/aaaa. Ver la nota en `fechaAlta`.
    format: "date",
  },
  {
    field: "fechaAlta",
    headerName: "Fecha Inicio",
    minWidth: 100,
    // `format: "date"` es el mecanismo del propio generateColumns: pasa el valor por
    // transformDate, que es el helper que usa toda la app (2026-09-18 -> 18/09/2026).
    format: "date",
  },
  {
    field: "status",
    headerName: "Estado",
    width: 100,
    // La fila guarda la ETIQUETA en `status` (es lo que ordena y se busca) y el codigo
    // crudo en `statusCod`. De ahi sale el color; el texto sale de la etiqueta.
    renderCell: ({ value, row }) => (
      <EstadoAgenteChip cod={row?.statusCod} label={value} />
    ),
  },
  {
    field: "fechaCarga",
    headerName: "Fecha Estado",
    flex: 1,
    maxWidth: 150,
    minWidth: 150,
    // `format: "date"` es el mecanismo del propio generateColumns: pasa el valor por
    // transformDate, que es el helper que usa toda la app (2026-09-18 -> 18/09/2026).
    format: "date",
  },
];

/**
 * Header de dos pisos de la grilla de agentes: "Mesas" arriba, "U" y "Q" abajo.
 *
 * Va aparte de `agentesTitles` y no mezclado con las columnas porque DataGrid lo
 * recibe por su propio prop (`columnGroupingModel`, que XGrid expone como
 * `columnGroups`). Los `field` de aca tienen que coincidir con los de arriba.
 */
export const agentesColumnGroups = [
  {
    groupId: "mesas",
    headerName: "Mesas",
    headerAlign: "center",
    children: [{ field: "unique" }, { field: "mesasCantidad" }],
  },
];

export const agenteDetailsTitles = [
  {
    field: "lugar",
    headerName: "Establecimiento / Repartición",
    flex: 1,
    minWidth: 250,
  },
  {
    // Minimo bajo a proposito: la celda TRUNCA y muestra el valor entero en un tooltip
    // (ver CAMPOS_TRUNCADOS en DetalleModal), asi que de 120 para abajo no se pierde el
    // dato. Sigue con `flex`, asi que en una pantalla ancha crece y no trunca nada.
    field: "cargo",
    headerName: "Cargo",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "funcion",
    headerName: "Función",
    flex: 1,
    minWidth: 160,
  },
  {
    // Sale del AGENTE, asi que repite el mismo valor en todas las filas. Va igual
    // porque es lo que explica que la columna de al lado tenga o no un horario: solo
    // un agente de horario FIJO se lleva uno en la asignacion.
    //
    // El header va en DOS RENGLONES ("Tipo de" / "Horario") para que la columna mida por
    // lo que MUESTRA —"Fijo", "Rotativo", "Sin asignar"— y no por el largo del titulo,
    // que era el doble. La regla de la clase vive en XGrid.module.scss.
    //
    // `width` y no `flex`: es una columna de valores cortos y fijos, no tiene por que
    // crecer con la grilla.
    field: "horarioTipo",
    headerName: "Tipo de Horario",
    headerClassName: "header-dos-lineas",
    headerAlign: "center",
    align: "center",
    width: 90,
  },
  {
    // Este si es de la ASIGNACION: se elige al asignar el lugar.
    field: "horario",
    headerName: "Horario",
    flex: 1,
    minWidth: 120,
  },

  {
    // El lugar puede estar en un hospital distinto al del agente, asi que el nombre
    // del componente solo no alcanza para saber donde es.
    //
    // Tambien trunca con tooltip, por lo mismo que el cargo: "Hospital Dr. Ramon
    // Carrillo" no entra en ningun ancho razonable y pedir 180px por eso era caro.
    field: "hospital",
    headerName: "Hospital",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "status",
    headerName: "Estado",
    flex: 1,
    minWidth: 130,
    // La fila guarda la ETIQUETA en `status` (es lo que ordena y se busca) y el codigo
    // crudo en `statusCod`. De ahi sale el color; el texto sale de la etiqueta.
    renderCell: ({ value, row }) => (
      <EstadoAgenteChip cod={row?.statusCod} label={value} />
    ),
  },
  {
    field: "fechaEstado",
    headerName: "Fecha Estado",
    flex: 1,
    minWidth: 160,
    format: "date",
  },
];

export const hospitalesTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 100,
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "nivel",
    headerName: "Nivel de Complejidad",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "area",
    headerName: "Área Programa",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "zona",
    headerName: "Zona Sanitaria",
    minWidth: 140,
    maxWidth: 140,
  },
  {
    field: "cabecera",
    headerName: "Cabecera",
    minWidth: 140,
    maxWidth: 140,
  },
  {
    field: "localidad",
    headerName: "Localidad",
    minWidth: 140,
    maxWidth: 140,
  },
];

export const estructuraTitles = [
  {
    field: "cod",
    headerName: "Código",
    flex: 1
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1
  },
  {
    field: "domicilio",
    headerName: "Domicilio",
    flex: 3
  },
  {
    field: "hospitalAsignado",
    headerName: "Hospital Asignado",
    flex: 1
  },
]

/**
 * Los mismos, más los dos permisos. Los usan CAPS, puestos y postas.
 *
 * URESA y hospitales se quedan con `estructuraTitles` a secas, y no por simetría con que no
 * tengan los checkbox: ahí el valor lo decide el back validando el tipo, así que mostrarlo
 * en la tabla abre una pregunta —"¿por qué no puedo cambiarlo?"— que la pantalla no tiene
 * cómo contestar.
 */
export const estructuraConPermisosTitles = [
  ...estructuraTitles,
  ...COLUMNAS_DE_PERMISOS,
]

export const ServicioTitles = [
  {
    field: "cod",
    headerName: "Código",
    flex: 1
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 2
  },
  {
    field: "desc",
    headerName: "Descripción",
    flex: 3
  },
  {
    field: "dpto",
    headerName: "Departamento",
    flex: 3
  },
  {
    field: "division",
    headerName: "División",
    flex: 2
  },
  ...COLUMNAS_DE_PERMISOS,
];
export const ComponentesSecundariosTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    width: 380,
  },
  {
    field: "desc",
    headerName: "Descripción",
    flex: 1,
    minWidth: 180,
  },
];
export const DivisionTitles = [
  {
    field: "cod",
    headerName: "Código",
    maxWidth: 150,
    flex: 1
  },
  {
    field: "name",
    headerName: "Nombre",
    maxWidth: 200,
    flex: 1
  },
  {
    field: "desc",
    headerName: "Descripción",
    flex: 1
  },
  {
    field: "dpto",
    headerName: "Departamento",
    maxWidth: 250,
    flex: 1
  },
  ...COLUMNAS_DE_PERMISOS,
];
export const DepartamentoTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    width: 380,
  },
  {
    field: "desc",
    headerName: "Descripción",
    flex: 1,
    minWidth: 180,
  },
  ...COLUMNAS_DE_PERMISOS,
];
export const areasTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 180,
  },
  {
    field: "name",
    headerName: "Nombre",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "zonaName",
    headerName: "Zona Sanitaria",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "hospitalCabecera",
    headerName: "Hospital de Cabecera",
    width: 250,
  },
];

export const articulosTitles = [
  {
    field: "name",
    headerName: "Nombre del artículo",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "rubro",
    headerName: "Rubro",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "plural",
    headerName: "Plural del artículo",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "cant",
    headerName: "Cantidad máxima",
    flex: 1,
    minWidth: 180,
  },
];

export const asignacionTitles = [
  {
    field: "name",
    headerName: "Articulo",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "rubro",
    headerName: "Rubro",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "fechaEntrega",
    headerName: "Fecha disponible",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "cant",
    headerName: "Cantidad",
    headerAlign: "center",
    align: "right",
    minWidth: 50,
    maxWidth: 180,
  },
  {
    field: "cantDisponible",
    headerName: "Cantidad entregada",
    minWidth: 50,
    maxWidth: 180,
    align: "right",
  },
  {
    field: "asignado",
    headerName: "Asignado por",
    minWidth: 340,
  },
  {
    field: "fechaAsignacion",
    headerName: "Fecha de asignación",
    flex: 1,
    minWidth: 180,
  },
];

export const asignacionNavidadTitles = [
  {
    field: "fecha",
    headerName: "Fecha",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "rubro",
    headerName: "Rubro",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "programa",
    headerName: "Programa",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "cant",
    headerName: "Monto",
    flex: 1,
    minWidth: 180,
    align: "right",
    headerAlign: "right",
    sortable: false
  },
  {
    field: "asignado",
    headerName: "Asignado por",
    minWidth: 340,
    sortable: false
  },
  {
    field: "fechaAsignacion",
    headerName: "Fecha de asignación",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
];


export const movimientosBeneficiario = [
  "Fecha",
  "Cantidad",
  "Artículo",
  "Entregado por",
  "Identificador",
  "Latitud y Longitud",
];

export const movimientosDespachante = [
  "Fecha",
  "Cantidad",
  "Artículo",
  "Entregado a",
  "Identificador",
  "Latitud y Longitud",
];

export const resumenDisponibles = ["Fecha disponible", "Articulo", "Cantidad", "Asignado por", "Fecha asignación"];
export const resumenTransferencias = [
  "Fecha disponible",
  "Articulo",
  "Cantidad",
  "Transferido a ",
  "Fecha asignación"
];
export const resumenAsignaciones = [
  "Fecha disponible",
  "Articulo",
  "Cantidad",
  "Asignado por",
  "Fecha asignación"
];
export const resumenRetiro = [
  "Fecha entrega",
  "Articulo",
  "Cantidad",
  "Entregado por ",
  "Fecha disponible",
];
export const resumenNavidad = [
  {
    field: "Fecha",
    headerName: "Fecha",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "Movimiento",
    headerName: "Movimiento",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "Ingreso",
    headerName: "Ingreso",
    flex: 1,
    minWidth: 180,
    align: "right",
    headerAlign: "right",
    sortable: false
  },
  {
    field: "Egreso",
    headerName: "Egreso",
    flex: 1,
    minWidth: 180,
    align: "right",
    headerAlign: "right",
    sortable: false
  },
  {
    field: "Saldo",
    headerName: "Saldo",
    minWidth: 200,
    align: "right",
    headerAlign: "right",
    sortable: false
  },
  {
    field: "Contraparte",
    headerName: "Contraparte",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "Referencia",
    headerName: "Referencia",
    flex: 1,
    minWidth: 180,
    sortable: false
  },
  {
    field: "Programa",
    headerName: "Programa",
    flex: 1,
    minWidth: 180,
    sortable: false
  }
]
export const resumenComerciosNavidad = [
  {
    field: "Fecha",
    headerName: "Fecha",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "Movimiento",
    headerName: "Movimiento",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "Ingreso",
    headerName: "Ingreso",
    flex: 1,
    minWidth: 180,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "Egreso",
    headerName: "Egreso",
    flex: 1,
    minWidth: 180,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "Saldo",
    headerName: "Saldo",
    minWidth: 200,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "Contraparte",
    headerName: "Contraparte",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "Referencia",
    headerName: "Referencia",
    flex: 1,
    minWidth: 180,
  },
]

// ---------------------------------------------------------------------------
// Horarios y sus rangos. Dos tablas distintas: un HORARIO es el concepto con
// nombre y codigo, y sus RANGOS son las franjas concretas (entrada, salida y en
// que dias aplica). Mismo reparto que feriados y series de feriados.
// ---------------------------------------------------------------------------
export const horariosTitles = [
  {
    field: "cod",
    headerName: "Código",
    width: 140,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "descripcion",
    headerName: "Descripción",
    flex: 1,
    minWidth: 240,
  },
  {
    // La pinta la vista con un renderCell: el valor es un array de franjas, no
    // un texto, asi que sin renderCell la celda mostraria "[object Object]".
    field: "rangos",
    headerName: "Rangos Horarios",
    flex: 1,
    minWidth: 240,
    sortable: false,
  },
];

// Los dias van como columnas de ancho fijo con una marca: una franja aplica a
// varios dias, y verlos en columnas deja comparar dos franjas de un vistazo.
// El `field` es el MISMO codigo de dia que guarda el rango, asi la fila se arma
// sin tabla de traduccion.
const columnaDia = (field, headerName) => ({
  field,
  headerName,
  flex: 1,
  align: "center",
  headerAlign: "center",
  sortable: false,
});

export const rangosTitles = [
  {
    field: "entrada",
    headerName: "Entrada",
    flex: 1,
  },
  {
    field: "salida",
    headerName: "Salida",
    flex: 1,
  },
  columnaDia("LU", "Lunes"),
  columnaDia("MA", "Martes"),
  columnaDia("MI", "Miércoles"),
  columnaDia("JU", "Jueves"),
  columnaDia("VI", "Viernes"),
  columnaDia("SA", "Sábado"),
  columnaDia("DO", "Domingo"),
];

// ---------------------------------------------------------------------------
// Historial de lugares de un agente. Es AUDITORIA: un movimiento por fila, con
// quien lo hizo y cuando. No se opera sobre el, solo se mira, asi que muestra mas
// columnas que la tabla de lo vigente —ahi el ancho se reparte entre los datos
// sobre los que se actua—.
// ---------------------------------------------------------------------------
export const agenteHistorialTitles = [
  {
    field: "fecha",
    headerName: "Fecha",
    width: 160,
  },
  {
    field: "accion",
    headerName: "Movimiento",
    width: 140,
  },
  {
    field: "lugar",
    headerName: "Establecimiento / Repartición",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "hospital",
    headerName: "Hospital",
    flex: 1,
    minWidth: 160,
  },
  {
    field: "funcion",
    headerName: "Función",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "cargo",
    headerName: "Cargo",
    width: 110,
  },
  {
    field: "status",
    headerName: "Estado",
    width: 120,
  },
  // FALTA la columna "Usuario", que es la mitad del valor de una auditoria: sin ella
  // se sabe que paso, no quien fue. El historial trae `rnhAgenteLugarHistUid`, pero es
  // un ID: mostrarselo a alguien no le dice nada. Se agrega en cuanto el back resuelva
  // el nombre y el apellido, y el mapeo de la fila ya quedo listo para eso.
];
